import { SvgIcon, SvgIconProps } from "@mui/material";

export const BoldIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <g clip-path="url(#a)">
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M7 6.077h5.875a3 3 0 0 1 3 3v0a3 3 0 0 1-3 3H7v-6Z"
          clip-rule="evenodd"
        />
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M7 12.077h7a3 3 0 0 1 3 3v0a3 3 0 0 1-3 3H7v-6Z"
          clip-rule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  </SvgIcon>
);
